export const getTokenId = state => state.tokenId;



// WEBPACK FOOTER //
// ./src/store/reducers/tokenId/selectors.js